import { DateTime } from 'luxon';
import { EntityType, Event, EventType } from './events';
import { AdminParsers } from '../admin/admin-parsers';

export namespace EventParsers {
  export class EventJson {
    id!: string;
    entityType!: string;
    entityId?: number;
    entityUuid?: string;
    eventType!: string;
    timestamp!: string;
    admin?: AdminParsers.AdminJson;
    metadata?: any;
  }

  export function toEvent(json: EventJson): Event {
    return {
      ...json,
      entityType: json.entityType as EntityType,
      eventType: json.eventType as EventType,
      timestamp: DateTime.fromISO(json.timestamp),
      admin: json.admin ? AdminParsers.toAdmin(json.admin) : undefined,
    };
  }
}
